<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-hover">
      <thead>
        <tr>
          <th>Tienda</th>
          <th>Número</th>
          <th>Motivo Ajuste</th>
          <th>Fecha</th>
          <th>Usuario</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="current in dataTabla.results" v-bind:key="current.id" @click="rowClick(current)">
          <td>{{ current.tienda.nombre }}</td>
          <td>{{ current.numero }}</td>
          <td>{{ current.motivo_ajuste }}</td>
          <td>{{ current.fecha }}</td>
          <td>
            {{ current.usuario.name }} &nbsp;
            <i class="fas fa-user-alt	"></i>
          </td>
          <td class="text-center">
            <div data-title="Activo" data-toggle="tooltip" v-html="current.estado_str"></div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="onPageChange" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      dataTabla: "ajusteinventario/ajuste_inventario",
    }),
  },
  mounted() {
    this.$store.dispatch("ajusteinventario/fetch");
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-ajuste_inventario-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-ajuste_inventario-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("ajusteinventario/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>
